const ContestPartners = (gist, partners, type) => {
  const partnersMap = partners
    .filter((partner) => partner.type === "primary")
    .map((partner) =>
      type === "name" ? partner.partner.name : partner.privacy_url
    )
  const primaryPartners = gist ? [gist].concat(partnersMap) : partnersMap
  let primaryPartnersString = ""
  primaryPartners.forEach((partner, index) => {
    let partnerString = ""
    if (primaryPartners.length > 2 && index > 0)
      partnerString = partnerString.concat(", ")
    if (index + 1 === primaryPartners.length && primaryPartners.length > 1)
      partnerString = partnerString.concat(" and")
    partnerString = partnerString.concat(` ${partner}`)
    primaryPartnersString = primaryPartnersString.concat(partnerString)
  })
  return primaryPartnersString
}

export default ContestPartners
